const styles = theme => ({
  topBar: {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    width: "100%",
    background: theme.palette.primary.main,
    color: "#fff",
    textTransform: "uppercase",
    padding: `${theme.spacing(4)}px 0`,
    textAlign: "center",
    "&> button": {
      paddingTop: 0,
      paddingBottom: 0
    }
  },
  iconButton: {
    position: "relative",
    borderRadius: "50%",
    height: "36px",
    width: "36px",
    marginLeft: theme.spacing(2)
  },
  backIcon: {
    position: "absolute",
    left: 10,
    height: "18px"
  },
  title: {
    position: "absolute",
    width: "100%",
    textAlign: "center"
  },
  form: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `0 ${theme.spacing(6)}px`,
    marginTop: theme.spacing(14),
    width: "300px",
    alignSelf: "center"
  },
  helpToggle: {
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-start",
    padding: 0,
    marginTop: theme.spacing(2),
    background: "transparent",
    border: "none",
    outline: "none"
  },
  helpInfoContainer: {
    width: "95%",
    "& > div": {
      width: "75%",
      margin: "0 auto",
      fontSize: 10
    }
  },
  helpInfo: {
    marginTop: theme.spacing(2)
  },
  submitContainer: {
    marginTop: theme.spacing(10)
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/App/AddOrg/styles.js